<template>
  <b-container fluid>
    <b-row class="heading_alignment">
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-8">
            <h4>
              <i class="fa-solid fa-square-poll-vertical pull-left mt-1" aria-hidden="true" style="font-size: 20px; margin-right: 3px; color: var(--iq-primary);"></i>
              Attempts: {{ quizDetail?.app_category.toUpperCase() }}
            </h4>
            <span v-if="userDetails"><b>Student Name:</b>&nbsp;<span @click="gotoUserProfile(userDetails?.user_id)" class="primary-color">{{userDetails?.user_name}}</span></span><br>
            <span v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"><b>Student Id:</b>&nbsp;<span class="primary-color" @click="gotoUserProfile(userDetails?.user_id)">{{userDetails?.user_id}}</span></span>
          </div>
          <div class="col-4">
            <h4>
              <b-button v-if="showAttemptNowButton" class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToAppDetail()">
                Attempt Now
              </b-button>
              <!-- Test only (admin, non-prod): opens the new V1 quiz screen QuestionQuizFullPageV1 -->
              <b-button v-if="showAttemptNowButton && (userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118')" class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" style="background-color: #324dc7; border-color: #324dc7; color: #fff;" @click="$router.push(`/assessment/quizv1/${appId}`)">
                Attempt Now
              </b-button>
            </h4>
          </div>
        </div>
        <div class="iq-card p-3 row">
          <b-col lg="10" xl="10">
            <b-row>
              <b-col class="col-12 mb-3">
                <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </div>
        <div class="iq-card p-3 row">
          <b-col class="container_minheight" md="12" v-if="resultList && resultList.length > 0">
            <b-table
              :items="resultList"
              :fields="columns"
              responsive
            >
              <template v-slot:cell(app_name_alias)="data">
                <span>{{data.item.app_name_alias}}</span><br>
                <span v-if="data.item.attemptStatus == 'COMPLETED'">
                  <b-button variant="mr-1" title="View Report Card" v-if='data.item.subject_module_name.toLowerCase().includes("a-thon") || data.item.subject_module_name.toLowerCase().includes("mock")' :disabled="isAttemptResultLocked(data.item)" @click="goToAttemptResultView(data.item)"><i class="fa-solid fa-file-text font-size-20 pointer"></i></b-button>
                  <b-button variant="mr-1" title="View Assessment Analysis" :disabled="isAttemptResultLocked(data.item)" @click="goToAttemptAnalysisV1(data.item)"><i class="fa-solid fa-magnifying-glass-chart font-size-20 pointer"></i></b-button>
                  <b-button variant="mr-1" title="View Analytics" v-if='data.item.subject_module_name.toLowerCase().includes("a-thon") || data.item.subject_module_name.toLowerCase().includes("mock")' :disabled="isAttemptResultLocked(data.item)" @click="goToAnalysisV1Report(data.item)"><i class="fa-solid fa-chart-pie font-size-20 pointer"></i></b-button>
                  <b-button variant="mr-1" title="Delete Attempt" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" disabled><i class="fa-solid fa-trash font-size-20"></i></b-button>
                </span>
                <span v-else-if="data.item.attemptStatus == 'FORECLOSED'">
                  <b-button variant="mr-1" title="View Report Card" v-if='data.item.subject_module_name.toLowerCase().includes("a-thon") || data.item.subject_module_name.toLowerCase().includes("mock")' disabled><i class="fa-solid fa-file-text font-size-20 pointer"></i></b-button>
                  <b-button variant="mr-1" title="View Assessment Analysis" disabled><i class="fa-solid fa-magnifying-glass-chart font-size-20 pointer"></i></b-button>
                  <b-button variant="mr-1" title="View Analytics" v-if='data.item.subject_module_name.toLowerCase().includes("a-thon") || data.item.subject_module_name.toLowerCase().includes("mock")' disabled><i class="fa-solid fa-chart-pie font-size-20 pointer"></i></b-button>
                  <b-button variant="mr-1" title="Delete Attempt" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" disabled><i class="fa-solid fa-trash font-size-20"></i></b-button>
                </span>
                <span v-else>
                  <b-button variant="mr-1" title="View Report Card" v-if='data.item.subject_module_name.toLowerCase().includes("a-thon") || data.item.subject_module_name.toLowerCase().includes("mock")' disabled><i class="fa-solid fa-file-text font-size-20"></i></b-button>
                  <b-button variant="mr-1" title="View Assessment Analysis" disabled><i class="fa-solid fa-magnifying-glass-chart font-size-20"></i></b-button>
                  <b-button variant="mr-1" title="View Analytics" v-if='data.item.subject_module_name.toLowerCase().includes("a-thon") || data.item.subject_module_name.toLowerCase().includes("mock")' disabled><i class="fa-solid fa-chart-pie font-size-20"></i></b-button>
                  <b-button variant="mr-1" title="Delete Attempt" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" @click="showAttemptDeleteDialog(data.item)"><i class="fa-solid fa-trash font-size-20 pointer"></i></b-button>
                </span>
                <b-badge v-if="!data.item.scores_breakdown?.some(e => e.deleted == 2)" :style="setTagStyles(data.item.attemptStatus)" variant="none">{{resultStatusStringMap[data.item.attemptStatus]}}</b-badge>
                <b-badge v-else style="background-color:#fff;color:orange;border:1px solid orange;" class="pointer" :title="cvEvaluationInProgressMsg" variant="none">Evaluation In Progres</b-badge>
              </template>

              <template v-slot:cell(total_questions)="data">
                {{parseFloat(data.item.total_questions)}}
              </template>

              <!-- Scores are shown as 0 to the student till the result is published (deleted = 2) -->
              <template v-slot:cell(correct_answer)="data">
                {{isAttemptResultLocked(data.item) ? 0 : data.item.correct_answer}}
              </template>

              <template v-slot:cell(wrong_answer)="data">
                {{isAttemptResultLocked(data.item) ? 0 : data.item.wrong_answer}}
              </template>

              <template v-slot:cell(skipped_answer)="data">
                {{isAttemptResultLocked(data.item) ? 0 : data.item.skipped_answer}}
              </template>

              <template v-slot:cell(aprs_percentage)="data">
                {{isAttemptResultLocked(data.item) ? "0.00" : parseFloat(data.item.correct_answer / data.item.total_questions  * 100).toFixed(2)}}%
              </template>

              <!-- Time spent per Question -->
              <template v-slot:cell(total_time_spent_per_q)="data">
                {{data.item.total_time_spent_per_q | convertSecondsToMinutesAndSeconds}}
              </template>

              <template v-slot:cell(q_time_spent)="data">
                {{data.item.q_time_spent | convertSecondsToMinutesAndSeconds}}
              </template>

              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>

              <!-- Row clickable toggle -->
              <template v-slot:cell(attempt)="data">
                <span @click="data.toggleDetails" style="cursor: pointer;">
                  {{ data.item.attempt }} ▼
                </span>
              </template><!-- Row clickable toggle -->

              <!-- Row details slot -->
              <template v-slot:row-details="data">
                <b-table
                  hover
                  responsive
                  :items="data.item.scores_breakdown"
                  :fields="expandableTablecolumns"
                  :no-border-collapse="true"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :current-page="currentPage"
                  :per-page="perPage"
                >
                  <template v-slot:cell(app_name_alias)="data">
                    <span>{{data.item.app_name_alias}}</span><br>
                    <small v-if="userData?.user_role == 'USERROLE11111' || userData?.user_role == 'USERROLE11118'" style="font-size: 10px;">
                      AppId: {{data.item.app_id}}<br>
                      TestId: {{data.item.aprs_id}}<br>
                    </small>
                    <span v-if="data.item.status == 'COMPLETED'">
                      <b-button variant="mr-1" title="Take Assessment" disabled><i class="fa-solid fa-play font-size-20"></i></b-button>
                      <!-- Test only (admin, non-prod): play this module in the new V1 quiz screen (QuestionQuizFullPageV1) -->
                      <b-button v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" variant="mr-1" title="Take Assessment" disabled><i class="fa-solid fa-play font-size-20" style="color: #324dc7;"></i> </b-button>
                      <!-- Attempt analysis is already available in the main row -->
                      <!-- <b-button variant="mr-1" title="View attempt analysis" :disabled="isAppResultLocked(data.item)" @click="goToAttemptAnalysisV1(data.item)"><i class="fa-solid fa-magnifying-glass-chart font-size-20 pointer"></i></b-button> -->
                    </span>
                    <span v-else-if="data.item.status == 'FORECLOSED'">
                      <b-button variant="mr-1" title="Take Assessment" disabled><i class="fa-solid fa-play font-size-20"></i></b-button>
                      <!-- Test only (admin, non-prod): play this module in the new V1 quiz screen (QuestionQuizFullPageV1) -->
                      <b-button v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" variant="mr-1" title="Take Assessment" disabled><i class="fa-solid fa-play font-size-20" style="color: #324dc7;"></i> </b-button>
                      <!-- <b-button variant="mr-1" title="View attempt analysis" disabled><i class="fa-solid fa-magnifying-glass-chart font-size-20 pointer"></i></b-button> -->
                    </span>
                    <span v-else>
                      <b-button variant="mr-1" title="Take Assessment" @click="goToAppDetail(data.item)"><i class="fa-solid fa-play font-size-20 pointer"></i></b-button>
                      <!-- Test only (admin, non-prod): play this module in the new V1 quiz screen (QuestionQuizFullPageV1) -->
                      <b-button v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" variant="mr-1" title="Take Assessment" @click="$router.push(`/assessment/quizv1/${data.item.app_id}`)"><i class="fa-solid fa-play font-size-20 pointer" style="color: #324dc7;"></i> </b-button>
                      <!-- <b-button variant="mr-1" title="View attempt analysis" disabled><i class="fa-solid fa-magnifying-glass-chart font-size-20"></i></b-button> -->
                    </span>
                    <b-badge v-if="data.item.deleted != 2" :style="setTagStyles(data.item.status)" variant="none">{{resultStatusStringMap[data.item.status]}}</b-badge>
                    <b-badge v-else style="background-color:#fff;color:orange;border:1px solid orange;" class="pointer" :title="cvEvaluationInProgressMsg" variant="none">Evaluation In Progres</b-badge>
                  </template>

                  <template v-slot:cell(total_questions)="data">
                    {{parseFloat(data.item.total_questions)}}
                  </template>

                  <!-- Scores are shown as 0 to the student till the result is published (deleted = 2) -->
                  <template v-slot:cell(correct_answer)="data">
                    {{isAppResultLocked(data.item) ? 0 : data.item.correct_answer}}
                  </template>

                  <template v-slot:cell(wrong_answer)="data">
                    {{isAppResultLocked(data.item) ? 0 : data.item.wrong_answer}}
                  </template>

                  <template v-slot:cell(skipped_answer)="data">
                    {{isAppResultLocked(data.item) ? 0 : data.item.skipped_answer}}
                  </template>

                  <template v-slot:cell(aprs_percentage)="data">
                    <!-- {{parseFloat(data.item.aprs_percentage).toFixed(2)}}% -->
                    {{isAppResultLocked(data.item) ? "0.00" : parseFloat(data.item.correct_answer / data.item.total_questions  * 100).toFixed(2)}}%
                  </template>

                  <!-- Time spent per Question -->
                  <template v-slot:cell(total_question)="data">
                    {{data.item.time_spent_per_q | convertSecondsToMinutesAndSeconds}}
                  </template>

                  <template v-slot:cell(q_time_spent)="data">
                    {{data.item.q_time_spent | convertSecondsToMinutesAndSeconds}}
                  </template>

                  <template v-slot:cell(total_time_spent_per_q)="data">
                    {{data.item.total_time_spent_per_q | convertSecondsToMinutesAndSeconds}}
                  </template>

                  <template v-slot:cell(created_on)="data">
                    {{data.item.created_on | dateFormat}}
                  </template>
                </b-table>
              </template>
            </b-table>
          </b-col>
          <div v-else class="col-12 text-center text-muted">
            No attempt found. Please attempt a test to view the performance. <span class="primary-color pointer" @click="goToAppDetail()">Attempt Now</span>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- delete Attempt modal -->
    <b-modal
      v-model="showModelAttemptDelete"
      size="sm"
      title="Delete Attempt"
      no-close-on-backdrop
      no-close-on-esc
    >
      <p>{{ cvDelMessage }}</p>
      <template #modal-footer="">
        <b-button size="sm" @click="showModelAttemptDelete = false">
          {{ cvbtnModalCancel }}
        </b-button>
        <b-button size="sm" variant="primary" @click="tprepAttemptDelete()">
          {{ cvbtnModalDelOk }}
        </b-button>
      </template>
    </b-modal><!-- delete Attempt list -->
  </b-container>
</template>

<script>
import { TPrepResults } from "../../../FackApi/api/TPrepResults"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission"
import { Apps } from "../../../FackApi/api/apps.js"

const RESULT_UNPUBLISHED = 2

export default {
  name: "TPrepResultsList",
  data () {
    return {
      apiName: "tprep_attempt_list",
      VUE_APP_TRUSTED_EMAILS: process.env.VUE_APP_TRUSTED_EMAILS,
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      cvCardTitle: "TestSeries",
      cvSubjectModuleName: "",
      gideUserId: null,
      appId: null,
      quizDetail: null,
      interest_id: null,
      resultList: [],
      isAttemptListLoaded: false,
      cvSearchText: "Type to Search",
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 1000,
      sortBy: "name",
      sortDesc: false,
      userDetails: null,
      showModelAttemptDelete: false,
      delObj: null,
      cvDelMessage: "Are you sure you want to delete this test attempt?",
      cvbtnModalCancel: "Cancel",
      cvbtnModalDelOk: "Delete",
      cvEvaluationInProgressMsg: "Your answers are being evaluated. Final scores & report card will be published after evaluation",
      columns: [
        { label: "Attempt", key: "attempt", class: "text-left align-text-top", sortable: true },
        { label: "Module", key: "app_name_alias", class: "text-left align-text-top w-350px", sortable: true },
        { label: "Total Questions", key: "total_questions", class: "text-left align-text-top", sortable: true },
        { label: "Correct Answers", key: "correct_answer", class: "text-left align-text-top", sortable: true },
        { label: "Wrong Answers", key: "wrong_answer", class: "text-left align-text-top", sortable: true },
        { label: "Skipped Questions", key: "skipped_answer", class: "text-left align-text-top", sortable: true },
        { label: "Accuracy", key: "aprs_percentage", class: "text-left align-text-top", sortable: true },
        // { label: "Quiz Completion Time", key: "q_time_spent", class: "text-left align-text-top", sortable: true },
        // { label: "Avg. Time Spent / Question", key: "total_time_spent_per_q", class: "text-left align-text-top", sortable: true },
        { label: "Quiz Played On", key: "created_on", class: "text-left align-text-top w-100px", sortable: true }
      ],
      expandableTablecolumns: [
        { label: "Module", key: "app_name_alias", class: "text-left align-text-top w-350px", sortable: true },
        { label: "Total Questions", key: "total_questions", class: "text-left align-text-top", sortable: true },
        { label: "Correct Answers", key: "correct_answer", class: "text-left align-text-top", sortable: true },
        { label: "Wrong Answers", key: "wrong_answer", class: "text-left align-text-top", sortable: true },
        { label: "Skipped Questions", key: "skipped_answer", class: "text-left align-text-top", sortable: true },
        { label: "Accuracy%", key: "aprs_percentage", class: "text-left align-text-top", sortable: true }
        // { label: "Quiz Completion Time", key: "q_time_spent", class: "text-left align-text-top", sortable: true },
        // { label: "Avg. Time Spent / Question", key: "total_time_spent_per_q", class: "text-left align-text-top", sortable: true }
      ],
      interestId: null,
      resultStatusStringMap: {
        "INPROGRESS": "In-Progress",
        "COMPLETED": "Completed",
        "FORECLOSED": "Foreclosed"
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    /**
     * Show Attempt Now button only when none of the attempts are in-progress
     */
    showAttemptNowButton () {
      return this.isAttemptListLoaded && this.resultList.every(item => item.attemptStatus != "INPROGRESS")
    }
  },
  async beforeMount () {
    this.gideUserId = this.$route.query?.gide_user_id

    // Auth Access for Current User Role
    if (this.gideUserId && this.gideUserId != this.userData.user_id) {
      if (!userPermission(this, this.userData, this.apiName)) {
        this.$router.back()
      }
    }
  },
  mounted () {
    socialvue.index()
    this.appId = this.$route.params.appId
    this.interestId = this.$route.params.subjId
    this.gideUserId = this.$route.query?.gide_user_id ? this.$route.query?.gide_user_id : this.userData.user_id

    this.appView()
    this.getAllAttempts()
  },
  methods: {
    /**
     * Quiz View
     */
    async appView () {
      const appViewResp = await Apps.appView(this, this.appId)
      this.quizDetail = appViewResp.resp_data.data
    },
    /**
     * goTo Quiz/App Details
     */
    async goToAppDetail (appDetails = null) {
      let appId = appDetails?.app_id ? appDetails?.app_id : this.appId
      if (appDetails?.attemptStatus == "FORECLOSED") {
        appId = appDetails?.app_parent
      }

      this.$router.push(`/quiz_detail/${appId}?module=testseries`)
    },
    /**
     * goTo Analysis V1Report
     */
    goToAnalysisV1Report (appData) {
      window.open(`/analytics?app_id=${appData.app_id}&gide_user_id=${this.gideUserId}&interest_id=${this.interestId}&aprs_id=${appData.aprs_id}&attempt=${appData.attempt}`)
    },
    /**
     * goto User Profile
     */
    gotoUserProfile (UserId) {
      window.open(`/user/${UserId}`)
    },
    /**
     * getAllAttempts
     */
    async getAllAttempts () {
      const subjectModuleObj = {
        app_id: this.appId
      }

      subjectModuleObj.gide_user_id = this.gideUserId

      const resultList = await TPrepResults.tprepAttemptList(this, subjectModuleObj)
      this.userDetails = resultList?.user_details ? resultList.user_details : { user_id: "-", user_name: "-" }

      if (resultList.resp_status) {
        this.resultList = resultList.resp_data.data

        // Adding serial number
        this.resultList.forEach((e, i) => {
          e.action = null
          e.id = i + 1
        })

        for (let i in this.resultList) {
          let attemptStatus = "COMPLETED" // This is the final status of all the modules together
          this.resultList[i].attemptStatus = attemptStatus

          for (let j in this.resultList[i]?.scores_breakdown || []) {
            if (this.resultList[i]?.scores_breakdown[j]?.status == "FORECLOSED") {
              // If foreclosed then all status should get marked as foreclosed
              attemptStatus = this.resultList[i]?.scores_breakdown[j]?.status
            }
            else if (this.resultList[i]?.scores_breakdown[j]?.status == "INPROGRESS" || this.resultList[i]?.scores_breakdown[j]?.total_questions_attempted == 0) {
              attemptStatus = attemptStatus == "FORECLOSED" ? "FORECLOSED" : this.resultList[i]?.scores_breakdown[j]?.status
            }

            this.resultList[i].attemptStatus = attemptStatus
          }
        }

        this.interestId = this.resultList[0].interest_id
        this.cvCardTitle = this.resultList[0].app_name_title
        this.cvSubjectModuleName = this.resultList[0].app_name_alias
        // console.log(this.cvSubjectModuleName, "XXXXXX", this.resultList[0].subject_module_name.includes(":"), "XXXXXX", this.resultList[0])
      }
      else {
        this.resultList = []
      }

      this.isAttemptListLoaded = true
    },
    /**
     * isAppResultLocked
     * Student cannot see the result of an app while it is unpublished (deleted = 2, FRQ under evaluation)
     */
    isAppResultLocked (aprsObj) {
      const isAdminOrCounselor = this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118"
      return !isAdminOrCounselor && Number(aprsObj.deleted) === RESULT_UNPUBLISHED
    },
    /**
     * isAttemptResultLocked
     * Student cannot see the report card, analysis, analytics or scores while any app of the attempt is unpublished
     */
    isAttemptResultLocked (attemptObj) {
      return (attemptObj.scores_breakdown ?? []).some(aprsObj => this.isAppResultLocked(aprsObj))
    },
    /**
     * goTo AttemptResult View
     */
    goToAttemptResultView (attemptObj) {
      let url = "" // `/app_result_view_all/${attemptObj.app_id}/${attemptObj.user_id}/${attemptObj.aprs_id}/${attemptObj.attempt}/1`

      if (attemptObj.subject_module_name.includes("A-THON") || attemptObj.subject_module_name.includes("MOCK") || attemptObj.subject_module_name.includes("Mock")) {
        url = `/app_result_view_v1/${this.appId}/${attemptObj.user_id}/${attemptObj.aprs_id}/${attemptObj.attempt}`
      }
      this.$router.push(url)
    },
    /**
     * goTo AttemptAnalysis
     */
    goToAttemptAnalysis (attemptObj) {
      let url = `/app_result_analyse/${this.appId}/${attemptObj.user_id}/${attemptObj.aprs_id}?attempt=${attemptObj.attempt}`
      this.$router.push(url)
    },
    /**
     * goTo AttemptAnalysis
     */
    goToAttemptAnalysisV1 (attemptObj) {
      let url = `/app_result_analyse_v1/${this.appId}/${attemptObj.user_id}/${attemptObj.aprs_id}?attempt=${attemptObj.attempt}&interest_id=${this.interestId}`

      this.$router.push(url)
    },
    /**
     * setTagStyles
     */
    setTagStyles (resultStatus) {
      let styles = ""
      if (resultStatus == "INPROGRESS") {
        // Filter is selected so set a solid background with white text
        styles += `background-color:orange;color:#fff; !important`
      }
      else if (resultStatus == "FORECLOSED") {
        styles += `background-color:red;color:#fff; !important`
      }
      else if (resultStatus == "COMPLETED") {
        styles += `background-color:green;color:#fff; !important`
      }
      else {
        styles += `background-color:orange;color:#fff; !important`
      }

      return styles
    },
    /**
     * showAttemptDeleteDialog
     */
    showAttemptDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelAttemptDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showAttemptDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * tprepAttemptDelete
     */
    async tprepAttemptDelete () {
      try {
        if (!this.delObj) {
          return
        }
        let aprsIdArray = []

        // Extract primary aprs_id
        if (this.delObj.aprs_id) {
          aprsIdArray.push(this.delObj.aprs_id)
        }

        // Collect all child module aprs_ids
        if (this.delObj.scores_breakdown && Array.isArray(this.delObj.scores_breakdown)) {
          this.delObj.scores_breakdown.forEach(child => {
            if (child.aprs_id) {
              aprsIdArray.push(child.aprs_id)
            }
          })
        }

        // Join array into comma-separated string
        let aprsIdsCommaSeparated = aprsIdArray.join(",")

        let deletePayload = {
          user_id: this.delObj.user_id || this.gideUserId,
          acc_id: 1,
          aprs_id: aprsIdsCommaSeparated,
          attempt: this.delObj.attempt
        }

        await TPrepResults.tprepAttemptDelete(this, deletePayload)
        this.showModelAttemptDelete = false
        this.getAllAttempts()
      }
      catch (err) {
        this.showModelAttemptDelete = false
        console.error("Exception occurred at tprepAttemptDelete() and Exception:", err.message)
      }
    }
  }
}
</script>
<style>
.card-title{
  width: 100%;
}
</style>
